import React from "react";
import { connect } from "react-redux";
import PowerCLIPasswordField from "./PowerCLIPasswordField";
import PowerCLIUsernameField from "./PowerCLIUsernameField";
import CentralCredentialsField from "./CentralCredentialsField";
//import EnablePasswordField from "./EnablePasswordField";
//import EnablePasswordTextField from "./EnablePasswordTextField";

function PowerCLIConnectionFieldset({ disabled }) {

    return (
        <fieldset className="oct_fieldset oct_fieldset-inner oct_fieldset-powercli">
            <CentralCredentialsField disabled={disabled} />
            <PowerCLIUsernameField disabled={disabled} />
            <PowerCLIPasswordField disabled={disabled} />
        </fieldset>
    )

}

export default connect()(PowerCLIConnectionFieldset);
